import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div>
        <p class="signature">Made with &#9829; by Celes Medina</p>
      </div>
    </footer>
  );
}

export default Footer;
